define(['underscore'], function()
{
    var diagramNodes = {
        basic: ['node'],
        requirement: ['requirement'],
        activity: [
            'action', 'Activity_Initial',
            'Activity_ActivityFinal', 'Activity_FlowFinal',
            'fork-or-join',
            'decision-or-merge', 'Activity_Parameter'
        ],
        context: ['element', 'subject'],
        'customer-value-chain': ['organization', 'person'],
        dcase: ['goal', 'evidence', 'strategy', 'context', 'undeveloped'],
        'screen-transition': ['screen', 'event'],
        'task-chain-analysis': ['task', 'sync'],
        usecase: ['usecase', 'actor'],
        TestTree: ['TestTree_TestCase'],
        Structure: ['Block', 'ValueType'],
        ux: ['action', 'object', 'state', 'decision-or-merge'],
        Class: ['Class', 'Interface', 'Package'],
        Package: ['Package'],
        CircuitBlock: ['CircuitElement', 'CircuitGround', 'CircuitSwitch', 'CircuitTerminal']
    };

    var _cvcaLinkNodes = [
        {
            source: ['organization'],
            target: ['organization', 'person']
        },
        {
            source: ['person'],
            target: ['organization']
        }
    ];
    var linkNodes = {
        // basic
        link: {
            source: diagramNodes.basic,
            target: diagramNodes.basic
        },
        // requirement
        cont: {
            source: diagramNodes.requirement,
            target: diagramNodes.requirement
        },
        dreq: {
            source: diagramNodes.requirement,
            target: diagramNodes.requirement
        },
        // activity
        ObjectFlow: [
            {
                source: ['action', 'fork-or-join', 'decision-or-merge'],
                target: ['action', 'fork-or-join', 'decision-or-merge']
            },
            {
                source: ['Activity_Parameter'],
                target: ['action', 'fork-or-join', 'decision-or-merge']
            },
            {
                source: ['action', 'fork-or-join', 'decision-or-merge'],
                target: ['Activity_Parameter']
            },
            {
                source: ['action'],
                target: ['object']
            },
            {
                source: ['object'],
                target: ['action']
            },
            {
                source: ['action'],
                target: ['Block']
            },
            {
                source: ['Block'],
                target: ['action']
            }
        ],
        ControlFlow: [
            {
                source: ['action', 'fork-or-join', 'decision-or-merge',
                    'Activity_Initial', 'state'],
                target: ['action', 'fork-or-join', 'decision-or-merge',
                    'Activity_ActivityFinal', 'Activity_FlowFinal', 'state']
            }
        ],
        // context
        action: {
            source: diagramNodes.context,
            target: diagramNodes.context
        },
        // cvca
        affiliation: _cvcaLinkNodes,
        information: _cvcaLinkNodes,
        money: _cvcaLinkNodes,
        logistics: _cvcaLinkNodes,
        // dcase
        analyze: [
            {
                source: ['goal'],
                target: ['evidence', 'strategy', 'undeveloped']
            },
            {
                source: ['strategy'],
                target: ['evidence', 'goal', 'undeveloped']
            }
        ],
        because: {
            source: _.without(diagramNodes.dcase, 'context'),
            target: ['context']
        },
        // screen transition
        belong: {
            source: diagramNodes['screen-transition'],
            target: diagramNodes['screen-transition']
        },
        transition: {
            source: diagramNodes['screen-transition'],
            target: diagramNodes['screen-transition']
        },
        // task chain analysis
        include: {
            source: diagramNodes['task-chain-analysis'],
            target: diagramNodes['task-chain-analysis']
        },
        // usecase
        'communication-path': {
            source: ['actor'],
            target: ['usecase']
        },
        // testTree
        TestTree_Include: {
            source: diagramNodes.TestTree,
            target: diagramNodes.TestTree
        },
        // verify
        verify: {
            source: ['TestTree_TestCase'],
            target: ['requirement']
        },
        // refine
        refine: {
            source: ['usecase'],
            target: ['requirement']
        },
        //
        Part: {
            source: ['Block'],
            target: ['Block']
        },
        Shared: {
            source: ['Block'],
            target: ['Block']
        },
        Reference: {
            source: ['Block'],
            target: ['Block']
        },
        Composition: {
            source: ['Class', 'Interface'],
            target: ['Class', 'Interface']
        },
        Aggregation: {
            source: ['Class', 'Interface'],
            target: ['Class', 'Interface']
        },
        Association: {
            source: ['Class', 'Interface'],
            target: ['Class', 'Interface']
        },
        Generalization: [
            {
                source: ['Block'],
                target: ['Block']
            },
            {
                source: ['Class'],
                target: ['Class']
            },
            {
                source: ['Interface'],
                target: ['Interface']
            },
            {
                source: ['actor'],
                target: ['actor']
            },
            {
                source: ['usecase'],
                target: ['usecase']
            }
        ],
        transition: [
            {
                source: ['state'],
                target: ['action']
            },
            {
                source: ['action'],
                target: ['state']
            }
        ],
        satisfy: [
            {
                source: ['Block', 'Activity_Parameter'],
                target: ['requirement']
            }
        ],
        Realization: {
            source: ['Class'],
            target: ['Interface']
        },
        Nest: {
            source: ['Class', 'Interface', 'Package'],
            target: ['Package']
        },
        Dependency: [
            {
                source: ['Class'],
                target: ['Interface']
            },
            {
                source: ['Package'],
                target: ['Package']
            }
        ],
        Import: {
            source: ['Package'],
            target: ['Package']
        },
        Merge: {
            source: ['Package'],
            target: ['Package']
        },
        CircuitConnected: {
            source: diagramNodes.CircuitBlock,
            target: diagramNodes.CircuitBlock
        },
        CircuitRectified: {
            source: diagramNodes.CircuitBlock,
            target: diagramNodes.CircuitBlock
        },
        CircuitSignal: {
            source: diagramNodes.CircuitBlock,
            target: diagramNodes.CircuitBlock
        },
    };

    // source, target node から link を引くためのハッシュ
    var nodes2link = {};
    var _get = function(source, target) {
        var key = source + ':' + target;
        return key in nodes2link ? _.clone(nodes2link[key]) : [];
    };
    var _add = function(source, target, link) {
        var key = source + ':' + target;
        if(key in nodes2link) {
            nodes2link[key].push(link);
        } else {
            nodes2link[key] = [link];
        }
    };
    var _addAll = function(sources, targets, link) {
        _.each(sources, function(source) {
            _.each(targets, function(target) {
                _add(source, target, link);
            });
        });
    };
    _.each(linkNodes, function(j, type) {
        if(_.isArray(j)) {
            _.each(j, function(p) {
                _addAll(p.source, p.target, type);
            })
        } else {
            _addAll(j.source, j.target, type);
        }
    });

    return {
        getNodes: function(type) {
            return diagramNodes[type];
        },
        getLinks: function(source, target) {
            var links = _get(source, target);
            links.push('trace');
            return links;
        }
    };
});



// WEBPACK FOOTER //
// ./system/domain/value/diagrams.js